<template>
  <div class="item-box-content" style="padding-bottom: 0px;">
    <el-row>
      <el-col :span="24">
        <div class="title-font-style">
          <span>发货信息</span>
        </div>
      </el-col>
    </el-row>
    <el-form label-width="85px" style="padding: 20px 20px 0 20px;">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="配送方式：">
            <el-select v-model="queryParams.deliverMode">
              <el-option
                v-for="(item, index) in logisticsModeList"
                :label="item.label"
                :value="item.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="物流费用："
            v-show="queryParams.deliverMode === '物流配送' || queryParams.deliverMode === '快递配送'"
          >
            <el-select v-model="queryParams.expressFeeType">
              <el-option label="合同结算" value="合同结算"></el-option>
              <el-option label="客户承担" value="客户承担"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提货人：" v-show="queryParams.deliverMode === '客户自提'">
            <el-select v-model="queryParams.expressConsignee">
              <el-option label="客户" value="客户"></el-option>
              <el-option label="销售代提" value="销售代提"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-show="queryParams.deliverMode === '客户自提'">
          <el-form-item label="预计自提时间：" label-width="98px">
            <el-date-picker
              v-model="queryParams.expressDateAd"
              type="date"
              placeholder="选择日期"
              style="width:100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item label="备注：">
            <el-input type="textarea" :rows="2" v-model.trim="queryParams.expressMark"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="solid" v-show="queryParams.logistics !== 3"></div>

      <div v-show="queryParams.deliverMode !== '客户自提'">
        <el-row>
          <el-col :span="8">
            <el-form-item label="发货方式：">
              <el-select v-model="queryParams.deliverSet" @change="changeSendType">
                <el-option label="直接发货" value="直接发货"></el-option>
                <el-option label="代发" value="代发"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发货人：" label-width="120px">
              <el-select
                v-show="queryParams.deliverSet === '直接发货'"
                v-model="queryParams.deliverPeople"
                @change="changeVoObj"
              >
                <el-option
                  v-for="(val, index) in VoList"
                  :key="index"
                  :label="val.name"
                  :value="val.name"
                ></el-option>
              </el-select>
              <el-input
                v-show="queryParams.deliverSet !== '直接发货'"
                v-model.trim="queryParams.deliverPeople"
                placeholder="请填写收货人姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">
              <div v-show="queryParams.deliverSet === '直接发货'">{{ queryParams.deliverPhone }}</div>
              <el-input
               @input.native="onInput"
                v-show="queryParams.deliverSet !== '直接发货'"
                v-model.trim="queryParams.deliverPhone"
                placeholder="请填写联系电话"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-row :gutter="10">
              <el-col :span="14">
                <el-form-item label="收货人：">
                  <el-consignee
                    ref="consigneeRefs"
                    :InfoList="InfoList"
                    @changeName="changeName"
                    :params="consigneeParams"
                  ></el-consignee>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-button @click="onEditConsignee" type="primary">编辑</el-button>
                <el-button @click="onAddConsignee" plain type="primary">添加</el-button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：" label-width="120px">
              <el-select
                v-if="telList.crMobile && telList.crPhone"
                v-model="consigneeParams.receivePhone"
              >
                <el-option :label="telList.crMobile" :value="telList.crMobile"></el-option>
                <el-option :label="telList.crPhone" :value="telList.crPhone"></el-option>
              </el-select>
              <div v-else>
                <el-input @input.native="onInput" v-model="consigneeParams.receivePhone" disabled></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收货地址：">
              <span>{{ consigneeParams.receiveAddress }} {{consigneeParams.receiveInfo}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <!-------------- 添加 编辑收货人 -------------->
    <edit-consignee-dialog @getCustomer="getCustomer" :id="id" ref="editConsigneeDialogRefs"></edit-consignee-dialog>
  </div>
</template>
<script>
import { logisticsModeList } from '../../util/data'
import Consignee from '@/components/Consignee/index'
import editConsigneeDialog from '../../dialog/editConsigneeDialog'
export default {
  components: {
    'edit-consignee-dialog': editConsigneeDialog,
    'el-consignee': Consignee
  },
  props: ['id'],
  data() {
    return {
      VoList: [], // 直接发货人列表
      telList: {}, // 下拉电话
      logisticsModeList,
      InfoList: [], // 发货人列表
      consigneeParams: {}, // 收货人
      queryParams: {
        deliverMode: '快递配送',
        expressFeeType: '合同结算',
        deliverSet: '直接发货'
      }
    }
  },
  methods: {
    onInput(e) {
      // 过滤非数字和符号-
      const regName = /^[\d-]+$/
      if (!regName.test(e.target.value)) {
        e.target.value = ''
      } else {
        return true
      }
    },
    init(obj, num) {
      if (num === 1) {
        this.VoList = obj.customerRecevieMobileList
        if (obj.customerRecevieInfo) {
          this.changeName(obj.customerRecevieInfo)
        } else {
          this.consigneeParams = {}
        }
        this.InfoList = obj.customerRecevieInfoList
      } else {
        this.VoList = obj.customerRecevieMobileVoList
        this.consigneeParams = obj.orderContractReceive || {}
        this.$refs.consigneeRefs.onConsignee(this.id)
      }
    },
    changeSendType() {
      // 改变发货方式  清空发货人
      delete this.queryParams.deliverPeople
      delete this.queryParams.deliverPhone
    },
    changeVoObj(val) {
      //   发货人改变
      const tempObj = this.VoList.filter((ele) => ele.name === val)[0]
      this.queryParams.deliverPhone = tempObj.crPhone
        ? tempObj.crPhone
        : tempObj.crMobile
    },
    // ---------------------------      收货人信息            -------------------------
    onAddConsignee() {
      // 添加收货人
      this.$refs.editConsigneeDialogRefs.onInitial('添加收货人')
    },
    onEditConsignee() {
      // 编辑收货人
      if (this.consigneeParams.id && this.consigneeParams.receivePeople) {
        this.$refs.editConsigneeDialogRefs.onInitial(
          '修改收货人',
          this.consigneeParams
        )
      } else {
        this.$message.error('请选择需要编辑的收货人!')
      }
    },
    // 确认添加收货人信息刷新组件列表
    getCustomer(obj) {
      this.consigneeParams = obj
      this.$refs.consigneeRefs.onConsignee(this.id, obj.id)
    },

    // 获取选择的收货人
    changeName(item) {
      if (item.crProcode || item.crProvince) {
        const recParams = this.$analysisAddress(item.crProcode, item.crProvince)
        item.provinceReceiving = recParams.province
        item.cityReceiving = recParams.city
        item.districtReceiving = recParams.district
      }
      this.consigneeParams = item
      this.consigneeParams.receiveAddress = item.crProvince
      this.consigneeParams.receiveInfo = item.crAddress
      this.consigneeParams.receivePeople = item.crName
      if (item.customerRecevieMobileVoList) {
        this.telList = item.customerRecevieMobileVoList[0] // 下拉电话
        if (this.telList.crMobile && !this.telList.crPhone) {
          this.consigneeParams.receivePhone = this.telList.crMobile
        }
        if (this.telList.crPhone) {
          this.$set(this.consigneeParams, 'receivePhone', this.telList.crPhone)
        }
      }
      if (item.crPhone) {
        this.$set(this.consigneeParams, 'receivePhone', item.crPhone)
      }
    }
  }
}
</script>
